<template>
<div class="form-panel"> 
    <div class="form-panel__header">
      <h2 class="titulo-h2">Indica tu fecha de nacimiento</h2>
    </div>
    <div class="form-panel__body">
      <v-date-picker ref="picker" class="grid-center font-family-roboto" locale="es-co" color="pink" header-color="light-blue" year-icon="event" :min="min" :max="max"  v-model="fecha" :landscape="landscape" :reactive="reactive"></v-date-picker>
    </div>
    <div class="form__group">
      <a v-if="guardar" class="waves-effect waves-light m-btn" tabindex="0" @click="guardarFecha()">Guardar</a>               
    </div> 
  </div> 
</template>
<script>

export default {
  data () {
    return {
      fechaInicial: null,
      fecha: null,
      guardar: false,
      landscape: false,
      reactive: true 
    }
  },
  watch: {
 	  fecha(newVal, oldVal) {
      if(!this.fechaInicial && newVal && this.$refs.picker.activePicker == 'DATE' && oldVal != newVal)
      {
        this.guardar = true
      }
      else if(this.fechaInicial && newVal != this.fechaInicial && newVal != oldVal)
      {
        this.guardar = true
      }
      else {
        this.guardar = false 
      }      
     }
  },
  computed: {
    min() {
      let fechaActual = new Date()
      return new Date(fechaActual.setFullYear(fechaActual.getFullYear() - 100 )).toISOString().substr(0, 10)
    },
    max() {
      let fechaActual = new Date()
      return new Date(fechaActual.setFullYear(fechaActual.getFullYear() - 18 )).toISOString().substr(0, 10)
    }
  },
  methods: {
    guardarFecha() {
      let parametros = this.fecha.split('-')
      let year = Number(parametros[0])
      let month = Number(parametros[1])
      let day = Number(parametros[2])

      this.$store.dispatch('guardarFechaNacimiento', { year, month, day })
    }
  },
  created() {

    let cliente = this.$store.getters.cliente

    if(cliente.fechaNacimiento)
    {
      this.fechaInicial = new Date(cliente.fechaNacimiento).toISOString().substr(0, 10)
      this.fecha = this.fechaInicial
    }

    if(!this.fecha)
    {
      this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  }
}
</script>

<style>

</style>
